import { Box, Button, Typography } from '@mui/material'
import React from 'react'

interface OfferEmptyStateProps {
    icon: React.ReactNode
    title: string
    description: string
    primaryAction?: {
        label: string
        href: string
    }
    secondaryAction?: {
        label: string
        href: string
    }
}

const OfferEmptyState: React.FC<OfferEmptyStateProps> = ({
    icon,
    title,
    description,
    primaryAction,
    secondaryAction
}) => {
    return (
        <Box
            sx={{
                textAlign: 'center',
                py: { xs: 6, md: 0 },
                pb: { md: 10 },
                px: { xs: 2, md: 4 },
                maxWidth: '600px',
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 3
            }}
        >
            {/* Icon Container */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // background: 'linear-gradient(rgb(193, 198, 206) -109.98%, rgba(193, 198, 206, 0) 32.6%)',
                    borderRadius: '50%',
                    width: { xs: 50, md: 100 },
                    height: { xs: 50, md: 100 },
                    mb: 2
                }}
            >
                {icon}
            </Box>

            {/* Content */}
            <Box sx={{ maxWidth: '400px' }}>
                <Typography
                    variant="h5"
                    sx={{
                        color: 'textColors.primary',
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { xs: '1.25rem', md: '1.5rem' },
                        lineHeight: 1.3
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'textColors.secondary',
                        fontSize: { xs: '0.875rem', md: '1rem' },
                        lineHeight: 1.5,
                        mb: 4
                    }}
                >
                    {description}
                </Typography>

                {/* Action Buttons */}
                {(primaryAction || secondaryAction) && (
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'center',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: 'center'
                        }}
                    >
                        {primaryAction && (
                            <Button
                                variant="contained"
                                size="large"
                                href={primaryAction.href}
                                sx={{
                                    bgcolor: 'primary.main',
                                    color: 'white',
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 1,
                                    fontSize: { xs: '0.875rem', md: '1rem' },
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    minWidth: { xs: '180px', sm: 'auto' },
                                    boxShadow: 'none',
                                    '&:hover': {
                                        bgcolor: 'primary.dark',
                                        boxShadow: 1
                                    }
                                }}
                            >
                                {primaryAction.label}
                            </Button>
                        )}
                        {secondaryAction && (
                            <Button
                                variant="outlined"
                                size="large"
                                href={secondaryAction.href}
                                sx={{
                                    color: 'primary.main',
                                    borderColor: 'borders.default',
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 1,
                                    fontSize: { xs: '0.875rem', md: '1rem' },
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    minWidth: { xs: '180px', sm: 'auto' },
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        bgcolor: 'rgba(238, 114, 3, 0.04)'
                                    }
                                }}
                            >
                                {secondaryAction.label}
                            </Button>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export { OfferEmptyState }
export default OfferEmptyState
export type { OfferEmptyStateProps }
